import React from 'react'

const VehicleOffersResponse = () => {
  return <div>Vehicle Offers Response</div>
}

export default VehicleOffersResponse



// WEBPACK FOOTER //
// ./src/ndc/offer/VehicleOffersResponse.js